import React from 'react';

export function CharactersIcon({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="m10 2 1.5 5h5l-4 3 1.5 5-4-3-4 3 1.5-5-4-3h5z"
      />
    </svg>
  );
}
